<template>
    <div class="container">
        <app-banner/>

        <div class="content-card-index-container justify-content-center row">
            <content-card
                    class="col-sm"
                    media="emojis/emoji-sunglasses-240x240.png"
                    title="Elev"
                    type="index"
                    v-on:onClick="onSelectStudent"
            />

            <content-card
                    class="col-sm"
                    media="emojis/emoji-nerd-240x240.png"
                    title="Lærer"
                    type="index"
                    v-on:onClick="onSelectTeacher"
            />
        </div>
    </div>
</template>

<script>
    import AppButton from '@/components/app-button'
    import ContentCard from '@/components/content-card'
    import AppBanner from '@/components/app-banner'

    import {getStudentUrl, getTeacherUrl} from '@/utils/UrlUtil';

    export default {
        components: {
            AppButton,
            ContentCard,
            AppBanner
        },
        methods: {
            onSelectStudent() {
                this.$router.push(getStudentUrl('index'));
            },
            onSelectTeacher() {
                this.$router.push(getTeacherUrl('index'));
            }
        }
    }
</script>

<style lang="less" scoped>
    .button-container div {
        text-align: center;
    }

    .content-card-index-container {
        text-align: center;
        align-items: center;
    }
</style>